import React, { Fragment } from "react";

import { ChargeButtonWrapper } from "./catalogue.styles";
import Button from "../../../../../../library/otherButton/Button";
import { formatKoboToNaira } from "../../../../../../utils/utilityFunctions";

const MobileChargeButton = ({ handleMobileCharge, totalPrice }) => {
    return (
        <Fragment>
            {totalPrice > 0 && (
                <ChargeButtonWrapper>
                    <Button
                        text={`Charge ${formatKoboToNaira(totalPrice)}`}
                        width="100%"
                        onButtonClick={handleMobileCharge}
                    />
                </ChargeButtonWrapper>
            )}
        </Fragment>
    );
};

export default MobileChargeButton;
